import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=2b2890c0&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=ts"
export * from "./AdditionalInfo.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=2b2890c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2890c0",
  null
  
)

export default component.exports